import React, { useState, useContext } from 'react';
import DisclaimerMessageUtil from './DisclaimerMessageUtil';
import { FormContext } from '../../../context/Form.context';
import { UMR_SOURCECODE, UMR_ENI_VISION_NOBENEFITS } from '../../../constants';

/**
 * Vision No Network Benefits Disclaimer Component
 * @component
 * @returns Vision No Network Benefits Disclaimer Component
 */
export default function VisionNoNetworkBenefitsDisclaimer() {
    const [showNoCostDisclaimer, setNoCostDisclaimer] = useState(true);
    const memberDetails = useContext(FormContext);
    const handleCloseIconClick = () => {
        setNoCostDisclaimer(false);
    };
    const dataTestID = 'noCost';
    const messageKey = 'Attention';
    const messageValue =
        memberDetails?.memberDetails?.sourceCode === UMR_SOURCECODE
            ? UMR_ENI_VISION_NOBENEFITS.text
            : " We're sorry, but cost information for this benefit is temporarily unavailable.";
    const isWarningDisclaimer = true;
    return (
        <>
            {showNoCostDisclaimer && (
                <DisclaimerMessageUtil
                    handleCloseIconClick={handleCloseIconClick}
                    messageKey={messageKey}
                    messageValue={messageValue}
                    dataTestID={dataTestID}
                    isWarningDisclaimer={isWarningDisclaimer}
                />
            )}
        </>
    );
}
